module.exports = __webpack_public_path__ + "img/carpaltunnel_1.c5b6ca19.gif";